<script setup>
    import { computed, defineProps, defineEmits } from "vue";

    const props = defineProps({
        total: { type: Number, required: true },
        per_page: { type: Number, default: 10 },
        last_page: { type: Number, default: 1 },
        modelValue: { type: Number, default: 1 },
        maxVisible: { type: Number, default: 3 },
        white: { type: Boolean, default: false }
    });

    const emit = defineEmits(["update:modelValue"]);

    const currentPage = computed({
        get: () => props.modelValue,
        set: (val) => {
            emit("update:modelValue", val);
        }
    });

    const totalPages = computed(() => props.last_page);

    const pages = computed(() => {
        const total = totalPages.value;
        const maxVisible = props.maxVisible;
        let start = Math.max(currentPage.value - Math.floor(maxVisible / 2), 1);
        let end = start + maxVisible - 1;

        if (end > total) {
            end = total;
            start = Math.max(end - maxVisible + 1, 1);
        }

        const arr = [];
        for (let i = start; i <= end; i++) arr.push(i);
        return arr;
    });

    const showFirstPage = computed(() => {
        const visiblePages = pages.value;
        return totalPages.value > 0 && visiblePages[0] !== 1;
    });

    const showFirstPageEllipsis = computed(() => {
        const visiblePages = pages.value;
        return showFirstPage.value && visiblePages[0] > 2;
    });

    const showLastPage = computed(() => {
        const visiblePages = pages.value;
        return totalPages.value > 0 && visiblePages[visiblePages.length - 1] !== totalPages.value;
    });

    const showLastPageEllipsis = computed(() => {
        const visiblePages = pages.value;
        return showLastPage.value && visiblePages[visiblePages.length - 1] < totalPages.value - 1;
    });

    function changePage(page) {
        if (page >= 1 && page <= totalPages.value) {
            currentPage.value = page;
        }
    }
</script>

<template>
    <div class="pagination sm justify-content-left mb-0 my-4"><!--white-->
        <button type="button" class="page-link" @click="changePage(currentPage - 1)" :class="{'active': currentPage === 1 }"><!--active -->
            <img src="/icons/icon-pagination-prev.svg" class="pagination-icon" alt="" />
            Précedent
        </button>
        <button type="button" class="page-link" @click="changePage(1)" v-if="showFirstPage" :class="{'active': currentPage === 1 }">1</button>
        <span class="page-link page-ellipsis" v-if="showFirstPageEllipsis">...</span>
        <button type="button" class="page-link" @click="changePage(page)"  v-for="page in pages" :key="page" :class="{'active': currentPage === page }">{{ page }}</button>
        <span class="page-link page-ellipsis" v-if="showLastPageEllipsis">...</span>
        <button type="button" class="page-link" @click="changePage(totalPages)" v-if="showLastPage" :class="{'active': currentPage === totalPages }">{{ totalPages }}</button>
        <button type="button" class="page-link pl-4" @click="changePage(currentPage + 1)" :class="{'active': currentPage === totalPages }">
            Suivant
            <img src="/icons/icon-pagination-next.svg" class="pagination-icon ml-2"
                alt="" />
        </button>
    </div>
</template>
